module.exports = __webpack_public_path__ + "img/secure_payment.1acd3f1d.png";